/** One label and one colour per streaming server type, used by every badge in the UI. */
export type ServerType = 'xaccel' | 'ssp' | 'ffstream';

export function serverTypeLabel(type: string | null | undefined): string {
  switch (type) {
    case 'ssp': return 'SSP';
    case 'ffstream': return 'FFStream';
    default: return 'X Accel';
  }
}

/** Short form for compact badges (status badges in lists): XC / SSP / FF. */
export function serverTypeShort(type: string | null | undefined): string {
  switch (type) {
    case 'ssp': return 'SSP';
    case 'ffstream': return 'FF';
    default: return 'XC';
  }
}

export function serverTypeColor(type: string | null | undefined): string {
  switch (type) {
    case 'ssp': return 'bg-violet-50 text-violet-700 border-violet-200';
    case 'ffstream': return 'bg-emerald-50 text-emerald-700 border-emerald-200';
    default: return 'bg-blue-50 text-blue-700 border-blue-200';
  }
}

/** Types offered when CREATING a server (FFStream stays editable/visible on existing rows but is not offered any more). */
export const CREATABLE_SERVER_TYPES: ServerType[] = ['xaccel', 'ssp'];
